import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=8708ddc6&scoped=true&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"
import style0 from "./platform.vue?vue&type=style&index=0&id=8708ddc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8708ddc6",
  null
  
)

export default component.exports